// extracted by mini-css-extract-plugin
export default {"title-user":"MySurvey_title-user__l4vqj"};